import {
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Text,
  Image,
  Link,
} from '@chakra-ui/react'
import {
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  EmailShareButton,
  LinkedinShareButton,
} from 'react-share'
import { toast } from 'sonner'

export default function SharePage({
  isOpen,
  onClose,
  url,
}: {
  isOpen: boolean
  onClose: () => void
  url: string
}) {
  const link = `https://lykstage.com/${url}`

  const copyToClipboardLink = () => {
    navigator.clipboard.writeText(link)
    toast.success('Copied to clipboard')
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={'sm'} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Share LYKSTAGE!</ModalHeader>
        <ModalCloseButton mt={2} />
        <hr />

        <>
          <ModalBody mb={5} mt={2}>
            {/* <VideoCard
              thumbnailUrl={videoData.thumbnailUrl}
              omitDetails={true}
              videoDuration={videoData.videoDuration}
              themeColor={videoData.themeColor || '#E79051'}
              creatorName={videoData.creatorName}
              title={videoData.title}
              watchTime={videoData.watchTime}
              channelShareName={''}
            /> */}

            <Image
              src="/how-earnings-work/share-lykstage.png"
              alt="Share LYKSTAGE"
            />

            <Flex
              mt={3}
              bg={'gray.100'}
              p={3}
              justifyContent={'space-between'}
              alignItems={'center'}
              rounded={'md'}
            >
              <Box>
                <Text fontWeight={500} fontSize={15}>
                  Copy link
                </Text>
                <Link fontWeight={500} fontSize={15} color={'#318FD2'}>
                  {`lykstage.com/${url}`}
                </Link>
              </Box>
              <Box className="cursor-pointer" onClick={copyToClipboardLink}>
                <Image boxSize={6} src={'/copy.svg'} alt="Copy" />
              </Box>
            </Flex>

            <Flex
              mt={3}
              bg={'gray.100'}
              p={3}
              justifyContent={'flex-start'}
              gap={4}
              alignItems={'center'}
              rounded={'md'}
            >
              <Text fontSize={15} fontWeight={500}>
                Share a link
              </Text>
              <FacebookShareButton url={link}>
                <Image
                  className="cursor-pointer"
                  boxSize={5}
                  src={'/socials/facebook.svg'}
                  alt="Copy"
                />
              </FacebookShareButton>
              <WhatsappShareButton url={link}>
                <Image
                  className="cursor-pointer"
                  boxSize={5}
                  src={'/socials/whatsapp.svg'}
                  alt="Copy"
                />
              </WhatsappShareButton>
              <TwitterShareButton url={link}>
                <Image boxSize={5} src={'/socials/twitter.svg'} alt="Copy" />
              </TwitterShareButton>
              <EmailShareButton url={link}>
                <Image boxSize={5} src={'/socials/email.svg'} alt="Copy" />
              </EmailShareButton>
              <LinkedinShareButton url={link}>
                <Image boxSize={5} src={'/socials/linkedin.svg'} alt="Copy" />
              </LinkedinShareButton>
            </Flex>

            {/* <Flex alignItems={'center'} mt={3} gap={1}>
              <Checkbox fontWeight={500}>Start video from</Checkbox>

              <Input
                type="text"
                variant={'unstyled'}
                color={'lyk-green'}
                border={'none'}
                height={5}
                textDecor={'underline'}
                fontWeight={700}
                flex={1}
                value={'1:00'}
              />
            </Flex> */}
          </ModalBody>
        </>
      </ModalContent>
    </Modal>
  )
}
